import { render, staticRenderFns } from "./view-endorsement-quote.vue?vue&type=template&id=cc327cc0&scoped=true&"
import script from "./view-endorsement-quote.vue?vue&type=script&lang=js&"
export * from "./view-endorsement-quote.vue?vue&type=script&lang=js&"
import style0 from "./view-endorsement-quote.vue?vue&type=style&index=0&id=cc327cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc327cc0",
  null
  
)

export default component.exports